import './styles.scss';
import moment from 'moment';
import AnnotationsShimmer from '../../components/shimmers-screen/annotation-screen-shimmer.vue';

export default {
    name: 'AnnotationsPage',

    components: {
        'annotations-shimmer': AnnotationsShimmer
    },

    data() {
        return {
            poll: false,
            loading: true  // Added loading state
        }
    },

    computed: {
        list() {
            return this.$store.getters.sharedAnnotations;
        },

        desktop() {
            return this.$store.state.desktop;
        }
    },

    watch: {
        list(newValue) {
            this.$store.commit('setMenuItems', this.list);
            // Hide shimmer when list is loaded
            if (newValue && newValue.length >= 0) {
                this.loading = false;
            }
        }
    },

    methods: {
        formatDate(data) {
            return moment(data).fromNow();
        },

        async setup() {
            this.$store.commit('setActiveMenu', true);
        },

        loadData() {
            this.loading = true;
            
            // Fetch all required data
            Promise.all([
                this.$store.dispatch('getStampsList'),
                this.$store.dispatch('fetchDocuments'),
                this.$store.dispatch('getSharedAnnotations')
            ]).then(() => {
                // Hide shimmer after a short delay for smooth transition
                setTimeout(() => {
                    this.loading = false;
                }, 500);
            }).catch(() => {
                this.loading = false;
            });
        }
    },

    mounted() {
        this.$store.commit('setActiveMenu', false);
        this.setup();
        this.loadData();  // Load data with shimmer
    },

    created() {
        this.$store.commit('setMenuItems', this.list);
        this.$store.commit('setMenuDetails', { title: 'Annotations Shared with You', slug: 'annotations' });

        // Start polling after initial load
        this.poll = window.setInterval(() => { 
            console.info('Refreshing annotations...'); 
            this.$store.dispatch('getSharedAnnotations'); 
        }, 10000);

        this.$store.commit('resetMessage');
        this.$store.commit('resetSearch');
    },

    beforeDestroy() {
        console.info("Unmounting annotations page...");
        window.clearInterval(this.poll);
    }
};
